import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  actions: {
    margin: theme.spacing(1),
    justifyContent: 'flex-end',
  },
}))

export default useStyles
